FroalaEditor.DefineIcon('conference', { NAME: 'conference'});
FroalaEditor.RegisterCommand('conference', {
    title: 'Conference',
    undo: true,
    focus: true,
    refreshAfterCallback: false,
    callback: function(cmd, source) {
        var newbox = document.createElement('div');
        var intro = document.createElement('p');
        intro.innerText = "Join this Zoom Meeting:";
        var link = document.createElement('a');
        link.innerText = 'https://zoom.us/j/91647348338?pwd=NTQ4Q2dUQkRVOHJKYXRPQTNsOWprUT09';
        link.href = 'https://zoom.us/j/91647348338?pwd=NTQ4Q2dUQkRVOHJKYXRPQTNsOWprUT09';
        newbox.append(intro);
        newbox.append(link);
        this.selection.element().appendChild(newbox);
    }
});
